import React from "react";
import '../styles/Skills.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faJava, faEthereum, faGit, faJs, faPython, faReact } from "@fortawesome/free-brands-svg-icons";


class Skills extends React.Component{
    render(){
        return(
            <div className="skills-div">
                <div className="sub-title-div">
                    <p className="tc">Skills</p>
                </div>
                <div className="skills-list-div">
                    <div className="skills-icons">
                        <ul>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faJava} />
                            </li>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faPython} />
                            </li>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faEthereum} />
                            </li>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faReact} />
                            </li>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faJs} />
                            </li>
                            <li className="animate-grow font_sec_color">
                                <FontAwesomeIcon icon={faGit} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>  
        );
    }
}

export default Skills;